// src/components/modal/useModal.ts
import { useState } from 'react';

interface UseModalProps {
  initialState?: boolean;
}

/**
 * Hook para gerenciar o estado do modal
 * @param initialState Estado inicial do modal (aberto ou fechado)
 * @returns Objeto com funções e estados para controlar o modal
 */
export const useModal = ({ initialState = false }: UseModalProps = {}) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const toggleModal = () => setIsOpen(prev => !prev);

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal,
  };
};

export default useModal;